/*RQ! code for "Navigation Update" STARTS*/
$( document ).ready(function() {
     $(".rq-dropdown-menu-click svg").click(function(){
       var get_val = $(this).attr("click-attr");
       if(get_val == "true") {
          $(".rq-menu-hide-open-click").slideDown();
          var get_val = $(this).attr("click-attr", 'false');
       }else{  
           $(".rq-menu-hide-open-click").slideUp();
           var get_val = $(this).attr("click-attr", 'true');
       }
     });  
});
/*RQ! code for "Navigation Update" ENDS*/

/*RQ! code for "Navigation Update" STARTS*/
$( document ).ready(function() {
     $(".rq-desktop-menu-open").hide();
     $(".rq-desktop-menu svg").click(function(){
       $(".rq-desktop-menu-open").slideUp();
        $(".rq-desktop-menu svg").removeClass("gbactive");
       var get_val = $(this).attr("click-attr2");
       if(get_val == "true") { 
          $(this).closest(".rq-main-inner-dropdown").find(".rq-desktop-menu-open").slideDown();
          var get_val = $(this).attr("click-attr2", 'false');
          $(this).addClass("gbactive");
       }else{  
           $(this).closest(".rq-main-inner-dropdown").find(".rq-desktop-menu-open").slideUp();
           var get_val = $(this).attr("click-attr2", 'true');
            $(this).removeClass("gbactive");
       }

     });  

     $(".rq-click-menu-mobile").click(function(){
       //  $("li.no-js-focus-wrapper.border-t-grid.border-grid-color ul li button").attr('aria-expanded', 'false');
       // $("li.no-js-focus-wrapper.border-t-grid.border-grid-color ul li ul").addClass('rq-hide-mobile-menu');
      // $("li.no-js-focus-wrapper.border-t-grid.border-grid-color ul li button").attr('aria-expanded', 'false');
        $(".rq-hide-defalut-menu").slideUp();
        $(".rq-click-menu-mobile").removeClass("gbactive");  
         var get_val_mob = $(this).attr("click-attr-menu");
        if(get_val_mob == "true") { 
          $(this).closest(".rq-main-menu-mobile").find(".rq-hide-defalut-menu").slideDown();
          var get_val = $(this).attr("click-attr-menu", 'false');
          $(this).addClass("gbactive");
        }else{  
           $(this).closest(".rq-main-menu-mobile").find(".rq-hide-defalut-menu").slideUp();
           var get_val = $(this).attr("click-attr-menu", 'true');
            $(this).removeClass("gbactive");
        }
     });
  
});
/*RQ! code for "Navigation Update" ENDS*/

$(document).ready(function(){

    // Select and loop the container element of the elements you want to equalise
    $('ul').each(function(){  
      
      // Cache the highest
      var highestBox = 0;
      
      // Select and loop the elements you want to equalise
      $('.rq-sameheightdiv', this).each(function(){
        
        // If this box is higher than the cached highest then store it
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
            
      // Set the height of all those children to whichever was highest 
      $('.rq-sameheightdiv',this).height(highestBox);
                    
    }); 

});

$(document).ready(function(){
   $(".rq-change-click").change(function(){
      $('.rq-submit-currency').trigger('click');
   });     
});  

$(document).ready(function(){
    var grt_html_bred = $('.rq-bredcrumbs-dropdown-main-title-get').html();
    $('.rq-append-col-link').html(grt_html_bred);
});  
/*$( document ).ready(function() {
  if ($('.rq-main-price-and-lead-time').css('display') === 'block') {
        $('.rq-sold-out-price-hide').css('opacity') = '0';
    }else{ 
        $(".rq-vendor-div").css({top: 22, position:'relative'});
    }
  if ($('.rq-main-price-and-lead-time').css('display') === 'block') {
        $('.rq-sold-out-price-hide').css('opacity') = '0';
    }else{ 
        $(".rq-vendor-div").css({top: 22, position:'relative'});
    }
}); */


$( document ).ready(function() {
   $(".variant-input").click(function(){
    setTimeout(function () {
       var get_val_path =  $(location).attr('href'); 
       const get_val_path_final = get_val_path.split("variant=");
       var get_val = get_val_path_final[1];
       var value = get_val;
       $(".rq-get-val-variant-metafiled-filter .rq-variant-lead-time-filter").filter(function() {
          $(this).toggle($(this).attr('value_option').toLowerCase().indexOf(value) > -1)
       });
     }, 500); 
   });  
});


$( document ).ready(function() {
   /*$(".rq-variant-id-color-swatch span").click(function(){
    //setTimeout(function () {
       var get_val_path =  $(this).attr('get_swatch_id'); 
       var value = get_val_path;
       $(".rq-get-val-variant-metafiled .rq-variant-lead-time-filter").filter(function() {
          $(this).toggle($(this).attr('value_option').toLowerCase().indexOf(value) > -1)
       });
     //}, 500); 
   });*/  
   //$(".rq-variant-id-color-swatch span").hover(function(){
   $('body').on('mouseenter', '.rq-variant-id-color-swatch span', function(){   
       var get_val_path =  $(this).attr('get_swatch_id'); 
       var value = get_val_path;
      
      $(this).closest(".rq-main-div-li-bg-color").find(".rq-get-val-variant-metafiled-swatch .rq-variant-lead-time-filter").filter(function() {
          $(this).toggle($(this).attr('value_option').toLowerCase().indexOf(value) > -1)
       });
      /* $(".rq-get-val-variant-metafiled-swatch .rq-variant-lead-time-filter").filter(function() {
          $(this).toggle($(this).attr('value_option').toLowerCase().indexOf(value) > -1)
       });*/
  });
});